/* TENSO — dormant header.

   The header stays pinned while the page moves, then settles out of the way
   once the reader stops. Scrolling again brings it back.

   The header is VISIBLE in CSS and this script only ever ADDS a class. If the
   file fails to load, or throws, the header simply stays where it is — the
   failure mode is a normal sticky header, never a missing one. That is the
   rule this theme has broken twice before.

   It also refuses to fade in the cases where hiding chrome is hostile:
   at the top of the page, while a drawer is open, while anything inside it
   holds focus, when the pointer is near the top edge, and whenever the reader
   has asked for reduced motion. */
(function () {
  "use strict";

  var header = document.querySelector(".site-header");
  if (!header) return;

  /* Reduced motion: a header that dissolves is motion. Leave it alone. */
  var quiet = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  if (quiet && quiet.matches) return;

  var IDLE = 1500;   /* stillness before it goes */
  var TOP = 60;      /* treat as "at the top", where it always stays */
  var EDGE = 120;    /* pointer this close to the top edge wakes it */

  var timer = null;

  function drawerOpen() {
    return !!document.querySelector(".drawer.open, .scrim.open");
  }

  function wake() {
    header.classList.remove("is-dormant");
    clearTimeout(timer);
    if (window.scrollY > TOP) timer = setTimeout(rest, IDLE);
  }

  function rest() {
    if (window.scrollY <= TOP) return;
    if (drawerOpen()) return;
    if (header.contains(document.activeElement)) return;
    header.classList.add("is-dormant");
  }

  window.addEventListener("scroll", wake, { passive: true });

  /* Reaching for it counts as asking for it. */
  window.addEventListener("pointermove", function (e) {
    if (e.clientY <= EDGE) wake();
  }, { passive: true });

  header.addEventListener("pointerenter", wake);
  document.addEventListener("focusin", function (e) {
    if (header.contains(e.target)) wake();
  });

  /* Opening a drawer must never leave the close control invisible. */
  document.addEventListener("click", function () {
    if (drawerOpen()) wake();
  }, true);

  wake();
})();
